import { TZyutyuHaisyaListGetRes } from "../../../../service/order/zyutyuHaisya/TZyutyuHaisya"
import {
  grid用プロパティ,
  T手入力チェック,
} from "../../../../ts/util/haisyaUtil"

export type T配車入力Grid = TZyutyuHaisyaListGetRes & {
  受注No?: string
  卸地分割部所ID?: number
  卸地分割部所名?: string
  卸地分割受注配車ID?: number
  請求対象フラグ?: number
} & grid用プロパティ &
  T手入力チェック

export const 未配車入力時非表示Bindings: (keyof T配車入力Grid | "卸地分割")[] =
  ["卸地分割", "卸地分割部所名", "トレーラ車番", "トレーラ車種区分名称1"]

export const 荷主Bindings = ["荷主コード", "荷主名", "表紙名", "荷主依頼番号"]
export const 積日Bindings = ["積日", "積時間"]
export const 卸日Bindings = ["卸日", "卸時間"]
export const 積地Bindings = [
  "積地積卸先コード",
  "積地社名",
  "積地都道府県",
  "積地市区町村",
]
export const 卸地Bindings = [
  "卸地積卸先コード",
  "卸地社名",
  "卸地都道府県",
  "卸地市区町村",
]

export const 品名Bindings = ["品コード", "品名", "積載品数量", "単位区分コード"]
export const 卸地車輌変更Bindings = ["卸地分割", "卸地分割部所名"]
export const 運転手計上Bindings = [
  "食事手当",
  "稼働手当車種掛率",
  "乗務員売上額",
  "乗務員付帯料",
  "付帯高速料",
  "特別手当",
  "is乗務員売上手編集",
  "稼働手当車種掛率区分コード",
  "同乗者売上額",
]

export const 請求Bindings = [
  "請求内訳コード",
  "荷主請求内訳ID",
  "請求区分コード",
  "単価",
  "請求車番",
  "請求運送料課税区分コード",
  "請求運送料",
  "請求付帯料課税区分コード",
  "請求付帯料",
  "請求高速料税込区分名称1",
  "請求高速料",
  "請求合計",
]

export const 分割受注配車子入力不可Bindings: (keyof T配車入力Grid)[] = [
  "受注配車パターンコード",
  "荷主コード",
  "荷主請求ID",
  "荷主依頼番号",
  "積日",
  "積時間",
  "卸日",
  "卸時間",
  "繰返運行数",
  "積地積卸先コード",
  "積地社名",
  "積地都道府県",
  "積地市区町村",
  "卸地積卸先コード",
  "卸地社名",
  "卸地都道府県",
  "卸地市区町村",
  "品名",
  "品コード",
  "積載品数量",
  "単位区分コード",
  "荷主請求内訳ID",
  "請求区分コード",
  "単価",
  "請求運送料課税区分コード",
  "請求運送料",
  "請求付帯料課税区分コード",
  "請求付帯料",
  "請求高速料",
  "請求備考",
  "支払運送料課税区分コード",
  "支払運送料",
  "支払付帯料課税区分コード",
  "支払付帯料",
  "支払高速料",
  "支払計上日",
  "支払備考",
]
